import React from "react";
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const CommonSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 37,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(17px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#fdd751",
        border: "none",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 16,
    backgroundColor: "#E0E0E0",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
}));

export default CommonSwitch;

